// ThemeConfigContext.tsx
import { createContext, useContext } from "react";
var ThemeConfigContext = createContext(null);
export var useThemeConfig = function () {
    var ctx = useContext(ThemeConfigContext);
    if (!ctx)
        throw new Error("useThemeConfig must be used inside ThemeConfigProvider");
    return ctx;
};
export default ThemeConfigContext;
